import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { get } from 'lodash';

/*************************************************************/

/**
 * @type {class}
 * @desc AuthFlowMemberVerificationHipaaAuthorization defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { AuthFlowMemberVerificationHipaaAuthorizationService } from 'services/authFlowMemberVerificationHipaaAuthorization';
 *
 * // create service instance and send/cancel request
 * const authFlowMemberVerificationHipaaAuthorizationService = new AuthFlowMemberVerificationHipaaAuthorizationService();
 * const result = await authFlowMemberVerificationHipaaAuthorizationService.fetchData( '<user-id>' ); // fetch data
 * authFlowMemberVerificationHipaaAuthorizationService.cancel(); // cancel an active request
 */
export class AuthFlowMemberVerificationHipaaAuthorizationService extends HttpService {

    // make request and fetch data
    async fetchComponentData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );
            

            // handle error
            if( SERVICE_RESPONSE_STATUS.ERROR === get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ) ) {
                return {
                    status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
                    data: get( response, 'body.component', {} ),
                };
            }

            // handle success
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
                data: get( response, 'body.component', {} ),
            };
        } catch( errResponse ) {
            return this._errorFormatter( errResponse );
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
